import React from 'react'
import blog1 from '../../images/blog/blogDetails1.jpg'
import blog2 from '../../images/blog/blogDetailsSmall1.jpg'
import blog3 from '../../images/blog/blogDetailsSmall2.jpg'
import author from '../../images/users/commentar1.jpg'
import blogs from '../../api/blogs';
import { Link } from "react-router-dom";
import { useParams } from 'react-router-dom'
import BlogSidebar from '../BlogSidebar';

const BlogSingle = (props) => {

    const { slug } = useParams()
    const BlogDetails = blogs.find(item => item.slug === slug)

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    return (
        <section className="stories pt-130 pb-100">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 mb-30">
                        <div className="innerWrapper">
                            <div className="donationDetails storiesDetails">
                                <div className="donationDetails__header mb-45">
                                    <figure className="thumb mb-45">
                                        <img src={BlogDetails.screens} alt="Gainioz blog" className="image-saturation" />
                                    </figure>
                                </div>
                                {/* BLOG BAŞLIĞI KALDIRILDI */}
                                <p className="donationDetails__text storiesDetails__text mb-30">We have covered
                                    many special events such as fireworks, fairs,
                                    parades, races, walks, awards ceremonies, fashion shows, sporting events, and even a memorial service.
                                </p>
                                <p className="donationDetails__text mb-30">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vulputate vestibulum rhoncus, dolor
                                    eget viverra pretium, dolor tellus aliquet nunc, vitae ultricies erat elit eu lacus. Vestibulum non
                                    justo consectetur, cursus ante, tincidunt sapien. Nulla quis diam sit amet turpis interd enim. Vivamus
                                    faucibus ex sed nibh egestas elementum. Mauris et bibendum dui. Aenean consequat pulvinar luctus.
                                    Suspendisse consectetur tristique tortor
                                </p>
                                {/* <h4 className="donationDetails__heading mb-25">{BlogDetails.title}</h4>  BLOG BAŞLIĞI GİTTİ */}
                                <p className="donationDetails__text mb-30">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur
                                    vulputate vestibulum Phasellus rhoncus, dolor eget viverra pretium, dolor tellus aliquet nunc, vitae
                                    ultricies erat elit eu lacus. Vestibulum non justo consectetur, cursus ante, tincidunt sapien. Nulla
                                    quis diam sit amet turpis interdum accumsan quis nec enim. Vivamus faucibus ex sed nibh egestas
                                    elementum. Mauris et bibendum dui. Aenean consequat pulvinar luctus</p>
                                <p className="donationDetails__text mb-30">We have covered many special events such as fireworks, fairs,
                                    parades, races, walks, awards ceremonies, fashion shows, sporting events, and even a memorial service.
                                </p>
                                <p className="donationDetails__text mb-40">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur
                                    vulputate vestibulum Phasellus rhoncus, dolor eget viverra pretium, dolor tellus aliquet nunc, vitae
                                    ultricies erat elit eu lacus. Vestibulum non justo consectetur, cursus ante, tincidunt sapien. Nulla
                                    quis diam sit amet turpis interdum accumsan quis nec enim. Vivamus faucibus ex sed nibh egestas
                                    elementum. Mauris et bibendum dui. Aenean consequat pulvinar luctus. Suspendisse consectetur tristique
                                    tortor</p>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <figure className="thumb mb-100">
                                            <img src={blog1} alt="Gainioz Blog" />
                                        </figure>
                                    </div>
                                </div>
                                {/* ... (devamı aynı şekilde kalabilir) */}
                                {/* Blog tags, paylaşım, yorumlar vb. */}
                                {/* Eğer başka bir başlık componenti varsa onu da kaldır! */}
                            </div>
                        </div>
                    </div>
                    <BlogSidebar />
                </div>
            </div>
        </section>
    )
}

export default BlogSingle;
